import { render } from "./PivotYearManagement.vue?vue&type=template&id=22115f6d"
import script from "./PivotYearManagement.vue?vue&type=script&lang=js"
export * from "./PivotYearManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__